import {
  CircularProgress,
  Paper,
  Stack,
  Table,
  TableBody,
  TableContainer,
  Typography,
} from "@mui/material";

import { NetworkCarrierTableHead } from "./NetworkCarrierTableHead";
import { ShipperPendingRequestTableRow } from "./ShipperPendingRequestTableRow";

interface Props {
  error: string | null;
  loading: boolean;
  pendingRequests: FollowShipperRequestAndResponse[];
  onRefetchFollowers: VoidFunction;
}

export function ShipperPendingRequests(props: Props) {
  const { error, loading, pendingRequests, onRefetchFollowers } = props;

  if (loading) {
    return (
      <Stack alignItems="center">
        <CircularProgress />
      </Stack>
    );
  }
  if (pendingRequests.length === 0) {
    return (
      <Stack>
        <Typography variant="h6" sx={{ ml: ".5rem" }}>
          No carriers here yet.
        </Typography>
      </Stack>
    );
  }
  return (
    <Stack
      direction="column"
      spacing={1}
      sx={{
        maxHeight: "500px",
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      {error != null && (
        <Typography color="red" align="center">
          {error}
        </Typography>
      )}
      <TableContainer component={Paper} variant="outlined">
        <Table size="small" sx={{ tableLayout: "fixed" }}>
          <NetworkCarrierTableHead />
          <TableBody>
            {pendingRequests.map((pr) => (
              <ShipperPendingRequestTableRow
                key={pr.request.id}
                pendingRequest={pr}
                onRefetchFollowers={onRefetchFollowers}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
}
